import api from "../../api/index.js";

const state = {
  orderList: null
};

const getters = {};

const actions = {
  OrderInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Order/Info",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  OrderView({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/Order/OrderView",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetApplyOrderPriceList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Order/GetApplyOrderPriceList",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetOrderQRcode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Order/GetOrderQRcode",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  WriteOffOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/TransactionOrder/WriteOff",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }
};

const mutations = {
  SetOrderList(state, payload) {
    state.orderList = payload.data;
    localStorage.setItem("orderList",JSON.stringify(state.orderList));
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/order.js